var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('worker_staff_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("worker_staff_page.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('worker_staff_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("worker_staff_page.form_desc")) + " ")]) : _vm._e(), _vm.workerInfo ? _c('b-card', {
    staticClass: "mt-3 mb-3",
    attrs: {
      "img-top": ""
    }
  }, _vm._l(_vm.showInfos, function (info) {
    return _c('div', {
      key: info.matched_key,
      staticClass: "field"
    }, [info.display && _vm.getWorkerInfo(info.matched_key) ? [_c('div', {
      staticClass: "field__label"
    }, [_vm._v(" " + _vm._s(info.title) + " ")]), _c('div', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(_vm.getWorkerInfo(info.matched_key)))])] : _vm._e()], 2);
  }), 0) : _vm._e(), _vm.getModuleConfig('worker_staff_page.content') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('worker_staff_page.content'))
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('worker_staff_page.button_text'),
      "button-url": _vm.getModuleConfig('worker_staff_page.button_url'),
      "type": _vm.getModuleConfig('worker_staff_page.button_action')
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }